import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import LivePlayer from "@/components/LivePlayer";
import ManifestoChapters from "@/components/ManifestoChapters";
import Schedule from "@/components/Schedule";
import PartnerBlock from "@/components/PartnerBlock";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import MobileBottomBar from "@/components/MobileBottomBar";
import InstallApp from "@/components/InstallApp";
import { AudioPlayerProvider } from "@/context/AudioPlayerContext";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    if (typeof window !== "undefined") window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    // Smooth anchor scroll for in-page nav links
    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id && id.length > 1) {
        const el = document.querySelector(id);
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -72 });
        }
      }
    };
    document.addEventListener("click", onClick);

    return () => {
      cancelAnimationFrame(rafId);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  return (
    <AudioPlayerProvider>
      <div className="App bg-[#070A0F] text-white min-h-screen antialiased selection:bg-cyan-400 selection:text-[#070A0F]">
        <Header />
        <main>
          <Hero />
          <EditorialMarquee />
          <LivePlayer />
          <ManifestoChapters />
          <Schedule />
          <InstallApp />
          <PartnerBlock />
          <Contact />
        </main>
        <Footer />
        <MobileBottomBar />
      </div>
    </AudioPlayerProvider>
  );
}

export default App;
